import { defineComponent as _defineComponent } from 'vue'
import SkeletonBox from '@/components/SkeletonBox.vue'
import { useTheme } from '@/composables/useTheme'
import { generateSalesBotStopIconSVG } from '@/utils/icon'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotItineraryItem',
  props: {
  loading: { type: Boolean, required: false },
  firstStop: { type: Boolean, required: false },
  lastStop: { type: Boolean, required: false },
},
  setup(__props) {

const props = __props;

const { themes } = useTheme()



const iconHTML = computed((): string => {
  return generateSalesBotStopIconSVG(themes.value?.light?.primary, props.lastStop, '16px', '16px')
})

return { __sfc: true,themes, props, iconHTML, SkeletonBox }
}

})